export default "__VITE_PUBLIC_ASSET__d75e4386__"